// extracted by mini-css-extract-plugin
export var discard = "_4n-3";
export var muiTooltipTooltip = "_4n-5";
export var notificationBar = "_4n-2";
export var saveButtonHoverSlotWrapper = "_4n-4";
export var show = "_4n-1";
export var spacer = "_4n-0";